var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FieldsViewControlsContainer grey lighten-4"},[(_vm.$vuetify.breakpoint.smAndDown)?_c('fields-view-controls-mobile'):_c('fields-view-controls-desktop'),_c('v-divider')],1)}
var staticRenderFns = []

export { render, staticRenderFns }